module.exports = __webpack_public_path__ + "static/media/business9.46fe03e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/business9.png
// module id = 89
// module chunks = 0